/**
 * Maybe stick element.
 *
 * @return void
 */
const headerElement = document.querySelector( 'header.stick' );
const secondaryNavigationElement = document.querySelector( '.nav-secondary' );
const stickyScrollPosition = 20;
let previousScrollY = window.scrollY;

const getAdminBarHeight = () => {
	const adminBar = document.querySelector( '#wpadminbar' );

	return adminBar ? Math.max( 0, adminBar.getBoundingClientRect().height ) : 0;
};

const getStickyScrollPosition = () => {
	if ( ! secondaryNavigationElement?.querySelector( 'nav a, nav button' ) ) {
		return stickyScrollPosition;
	}

	return Math.max(
		stickyScrollPosition,
		secondaryNavigationElement.getBoundingClientRect().bottom + window.scrollY - getAdminBarHeight()
	);
};

const updateStickyLogoProgress = () => {
	const currentScrollY = window.scrollY;
	const isScrollingUp = currentScrollY < previousScrollY;
	const scrollPosition = getStickyScrollPosition();
	const scrollProgress = currentScrollY <= 0
		? 0
		: isScrollingUp
			? 1
			: Math.min( 1, Math.max( 0, currentScrollY / scrollPosition ) );
	const progress = Math.min( 1, Math.max( 0, ( scrollProgress - .5 ) * 2 ) );

	document.documentElement.style.setProperty( '--samenwerkt-sticky-logo-fade', `${ 1 - progress * .75 }` );
	document.documentElement.style.setProperty( '--samenwerkt-sticky-logo-scale', `${ 1 - progress * .25 }` );
	previousScrollY = currentScrollY;
};

const updateHeaderHeight = () => {
	if ( headerElement ) {
		document.documentElement.style.setProperty( '--samenwerkt-header-height', `${ headerElement.offsetHeight }px` );
	}
};

const updateAdminBarState = () => {
	const adminBar = document.querySelector( '#wpadminbar' );

	if ( ! adminBar ) {
		return;
	}

	const adminBarBottom = Math.max( 0, adminBar.getBoundingClientRect().bottom );

	document.documentElement.style.setProperty(
		'--samenwerkt-admin-bar-offset',
		`${ adminBarBottom }px`
	);
};

const getFragmentTarget = () => {
	if ( ! window.location.hash ) {
		return null;
	}

	try {
		return document.getElementById( decodeURIComponent( window.location.hash.slice( 1 ) ) );
	} catch {
		return null;
	}
};

const alignFragmentTarget = ( target = getFragmentTarget() ) => {
	if ( ! target || target.matches( '.campaign-donation-column' ) || 'fixed' === window.getComputedStyle( target ).position ) {
		return;
	}

	const headerOffset = headerElement?.classList.contains( 'is-sticky' )
		? headerElement.getBoundingClientRect().bottom
		: 0;
	const targetTop = target.getBoundingClientRect().top + window.scrollY;

	window.scrollTo( {
		top: Math.max( 0, targetTop - headerOffset - 40 ),
		behavior: 'auto',
	} );
};

const scheduleFragmentAlignment = () => {
	window.requestAnimationFrame( () => {
		window.requestAnimationFrame( () => alignFragmentTarget() );
	} );
};

const maybeStickHeader = () => {
	const classList = headerElement.classList;
	const isSticked = classList.contains( 'is-sticky' );
	updateStickyLogoProgress();
	updateAdminBarState();

	// Stick.
	if ( ! isSticked ) {
		if ( window.scrollY >= getStickyScrollPosition() ) {
			classList.add( 'is-sticky' );

			// @todo use IntersectionObserver to unstick,
			//  so the `scroll` event can be ignored.
			//  document.removeEventListener('scroll', maybeStickHeader );
		}

		return;
	}

	// Unstick.
	if ( window.scrollY > 0 ) {
		return;
	}

	classList.remove('is-sticky');
}

/**
 * Event listeners.
 */
if ( headerElement ) {
	updateHeaderHeight();
	updateStickyLogoProgress();
	updateAdminBarState();

	if ( 'ResizeObserver' in window ) {
		new ResizeObserver( updateHeaderHeight ).observe( headerElement );
	}

	document.addEventListener( 'scroll', maybeStickHeader, { passive: true } );
}

window.addEventListener( 'hashchange', scheduleFragmentAlignment );
window.addEventListener( 'load', scheduleFragmentAlignment );
document.addEventListener( 'samenwerk:align-fragment-target', ( event ) => {
	const target = event.detail?.target;

	if ( ! target ) {
		return;
	}

	window.requestAnimationFrame( () => {
		window.requestAnimationFrame( () => alignFragmentTarget( target ) );
	} );
} );
scheduleFragmentAlignment();
